import axios from "axios";
import { getStorage } from "../utils/utils";

const ENDPOINT = {
  USER: {
    GET_USER_INFO: `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/refresh`,
    LOGIN: `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/login`,
    LOGIN_LINE: `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/line`,
    OMNI_IDENTITY: `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/omni-identity`,
    REGISTER: `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/member-register`,
    CHANGE_PASSWORD: `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/change-password`,
    SWITCH_POINT_MODE: (memberId) =>
      `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/set-enable-point/${memberId}`,
    ADD_WALLET: `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/change-wallet-id`,
    CHECK_INFORMATION: `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/check-information`,
  },

  DEPOSIT: {
    VALUE: `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/deposit-value`,
    CACHE_CHECK: `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/deposit-cache-check`,
    GET_DEPOSIT_HISTORY: (memberId, page) =>
      `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/deposit-history?member_id=${memberId}&page=${page}`,
  },

  SOURCE: {
    GET_SOURCE: `${window.env.REACT_APP_DEV_ENDPOINT}/sorce/list-sorce`,
  },

  WITHDRAW: {
    REQUEST: `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/withdraw`,
    GET_WITHDRAW_HISTORY: `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/withdraw-history`,
  },

  AFFILIATE: {
    GET_AFFILIATE_HISTORY: ({ page, limit, memberId }) =>
      `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/affiliate-history?page=${page}&limit=${limit}&member_id=${memberId}`,
    GET_AFFILIATE_TRX_HISTORY: (memberId) =>
      `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/affiliate-transaction?member_id=${memberId}`,
    AFFILIATE_RECEIVE_CREDIT: (memberId) =>
      `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/affiliate-receive?member_id=${memberId}`,
  },

  CASHBACK: {
    GET_CASHBACK_HISTORY: (memberId) =>
      `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/refund-credit-history/${memberId}`,
    RECEIVE_CASHBACK: (memberId) =>
      `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/refund-credit-receive/${memberId}`,
  },

  FIXED_DEPOSIT: {
    GET_FIXED_DEPOSIT_CONFIG: (memberId) =>
      `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/fixed-deposit/${memberId}`,
    RECIEVE_FIXED_DEPOSIT: `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/fixed-deposit-receive`,
  },

  IMAGE: {
    GET_IMAGE_CONFIG: `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/image-config`,
  },

  CREDIT_FREE: {
    ADD_CREDIT_FREE: `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/redeem-code`,
    CHECK_CODE: `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/check-code`,
    USE_CODE: `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/used-code`,
  },

  COUPON: {
    PREVIEW: `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/coupons/preview`,
    REDEEM: `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/coupons/redeem`,
    REDEMPTION: (requestId) =>
      `${window.env.REACT_APP_DEV_ENDPOINT}/member-hook/coupons/redemptions/${encodeURIComponent(
        requestId,
      )}`,
  },
};

const UserService = {
  getUserInfoById: (_id) => {
    return axios({
      method: "POST",
      url: ENDPOINT.USER.GET_USER_INFO,
      headers: { Authorization: `Bearer ${getStorage("token")}` },
      data: { member_id: _id },
    });
  },

  addWallet: (data) => {
    return axios({
      method: "POST",
      url: ENDPOINT.USER.ADD_WALLET,
      headers: { Authorization: `Bearer ${getStorage("token")}` },
      data,
    });
  },

  checkInformation: (requestData) => {
    return axios({
      method: "POST",
      url: ENDPOINT.USER.CHECK_INFORMATION,
      headers: { Authorization: `Bearer ${getStorage("token")}` },
      data: requestData,
    });
  },

  checkIP: () => {
    return axios({
      method: "GET",
      url: "https://api.ipify.org?format=json",
    });
  },

  memberRegister: (data) => {
    return axios({
      method: "POST",
      url: ENDPOINT.USER.REGISTER,
      headers: { Authorization: `Bearer ${getStorage("token")}` },
      data,
    });
  },

  memberLogin: (data) => {
    return axios({
      method: "POST",
      url: ENDPOINT.USER.LOGIN,
      headers: { Authorization: `Bearer ${getStorage("token")}` },
      data,
    });
  },

  memberLoginLine: (data) => {
    return axios({
      method: "POST",
      url: ENDPOINT.USER.LOGIN_LINE,
      headers: { Authorization: `Bearer ${getStorage("token")}` },
      data,
    });
  },

  getOmniIdentity: () => {
    return axios({
      method: "GET",
      url: ENDPOINT.USER.OMNI_IDENTITY,
      headers: { Authorization: `Bearer ${getStorage("token")}` },
    });
  },

  changePassword: (data) => {
    return axios({
      method: "POST",
      url: ENDPOINT.USER.CHANGE_PASSWORD,
      headers: { Authorization: `Bearer ${getStorage("token")}` },
      data,
    });
  },

  switchPointMode: (memberId) => {
    return axios({
      method: "GET",
      url: ENDPOINT.USER.SWITCH_POINT_MODE(memberId),
      headers: { Authorization: `Bearer ${getStorage("token")}` },
    });
  },

  getImageConfig: () => {
    return axios({
      method: "GET",
      url: ENDPOINT.IMAGE.GET_IMAGE_CONFIG,
      headers: { Authorization: `Bearer ${getStorage("token")}` },
    });
  },

  // ===== WITHDARW =======
  userWithdraw: (data) => {
    return axios({
      method: "POST",
      url: ENDPOINT.WITHDRAW.REQUEST,
      headers: { Authorization: `Bearer ${getStorage("token")}` },
      data,
    });
  },

  withdrawHistory: (data) => {
    return axios({
      method: "POST",
      url: ENDPOINT.WITHDRAW.GET_WITHDRAW_HISTORY,
      headers: { Authorization: `Bearer ${getStorage("token")}` },
      data,
    });
  },
  // =======================

  // ===== DEPOSIT =======
  depositValue: (data) => {
    return axios({
      method: "POST",
      url: ENDPOINT.DEPOSIT.VALUE,
      headers: { Authorization: `Bearer ${getStorage("token")}` },
      data,
    });
  },

  depositCheck: (member_id) => {
    return axios({
      method: "POST",
      url: ENDPOINT.DEPOSIT.CACHE_CHECK,
      headers: { Authorization: `Bearer ${getStorage("token")}` },
      data: { member_id },
    });
  },

  getDepositHistory: ({ memberId, page }) => {
    return axios({
      method: "GET",
      url: ENDPOINT.DEPOSIT.GET_DEPOSIT_HISTORY(memberId, page),
      headers: { Authorization: `Bearer ${getStorage("token")}` },
    });
  },

  // =======================

  // ===== CASH BACK ======
  getCashBackHistory: (memberId) => {
    return axios({
      method: "GET",
      url: ENDPOINT.CASHBACK.GET_CASHBACK_HISTORY(memberId),
      headers: { Authorization: `Bearer ${getStorage("token")}` },
    });
  },

  receiveCashBack: (memberId) => {
    return axios({
      method: "GET",
      url: ENDPOINT.CASHBACK.RECEIVE_CASHBACK(memberId),
      headers: { Authorization: `Bearer ${getStorage("token")}` },
    });
  },
  // =======================

  // ===== FIXED_DEPOSIT =====
  getFixedDepositConfig: (id) => {
    return axios({
      method: "GET",
      url: ENDPOINT.FIXED_DEPOSIT.GET_FIXED_DEPOSIT_CONFIG(id),
      headers: { Authorization: `Bearer ${getStorage("token")}` },
    });
  },

  recieveFixedBonus: (data) => {
    return axios({
      method: "POST",
      url: ENDPOINT.FIXED_DEPOSIT.RECIEVE_FIXED_DEPOSIT,
      headers: { Authorization: `Bearer ${getStorage("token")}` },
      data,
    });
  },
  // =======================

  // ===== AFFILIATE =======
  affiliateReceiveCredit: (memberId) => {
    return axios({
      method: "GET",
      url: ENDPOINT.AFFILIATE.AFFILIATE_RECEIVE_CREDIT(memberId),
      headers: { Authorization: `Bearer ${getStorage("token")}` },
    });
  },

  getAffiliateHistory: (memberId) => {
    return axios({
      method: "GET",
      url: ENDPOINT.AFFILIATE.GET_AFFILIATE_HISTORY(memberId),
      headers: { Authorization: `Bearer ${getStorage("token")}` },
    });
  },

  getAffiliateTrxHistory: (config) => {
    return axios({
      method: "GET",
      url: ENDPOINT.AFFILIATE.GET_AFFILIATE_TRX_HISTORY(config),
      headers: { Authorization: `Bearer ${getStorage("token")}` },
    });
  },
  // =======================

  // ==== AddCreditFree ====
  addCreditFree: (data) => {
    return axios({
      method: "POST",
      url: ENDPOINT.CREDIT_FREE.ADD_CREDIT_FREE,
      headers: { Authorization: `Bearer ${getStorage("token")}` },
      data,
    });
  },
  checkCode: (data) => {
    return axios({
      method: "POST",
      url: ENDPOINT.CREDIT_FREE.CHECK_CODE,
      headers: { Authorization: `Bearer ${getStorage("token")}` },
      data,
    });
  },
  usedCode: (data) => {
    return axios({
      method: "POST",
      url: ENDPOINT.CREDIT_FREE.USE_CODE,
      headers: { Authorization: `Bearer ${getStorage("token")}` },
      data,
    });
  },
  previewCoupon: (code) => {
    return axios({
      method: "POST",
      url: ENDPOINT.COUPON.PREVIEW,
      headers: { Authorization: `Bearer ${getStorage("token")}` },
      data: { code },
    });
  },
  redeemCoupon: ({ code, request_id }) => {
    return axios({
      method: "POST",
      url: ENDPOINT.COUPON.REDEEM,
      headers: { Authorization: `Bearer ${getStorage("token")}` },
      data: { code, request_id },
    });
  },
  getCouponRedemption: (requestId) => {
    return axios({
      method: "GET",
      url: ENDPOINT.COUPON.REDEMPTION(requestId),
      headers: { Authorization: `Bearer ${getStorage("token")}` },
    });
  },
  getSorce: () => {
    return axios({
      method: "GET",
      url: ENDPOINT.SOURCE.GET_SOURCE,
      headers: { Authorization: `Bearer ${getStorage("token")}` },
    });
  },
};

export default UserService;
